import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Camera } from "lucide-react";

const fmtTime = (s) => (s ? new Date(s).toLocaleString() : "—");

export default function ScreenshotActivity() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/admin/screenshot-events").then((r) => setEvents(r.data.events)).finally(() => setLoading(false));
  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);

  return (
    <div data-testid="screenshot-activity-page">
      <div className="overline" style={{ fontSize: 10, marginBottom: 10 }}>
        Detected screenshot attempts — Windows PrintScreen key only. macOS shortcuts, mobile screenshots and camera photos cannot be detected by a browser.
      </div>
      <div className="card-ledger overflow-hidden">
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead><tr style={{ background: "var(--surface-2)" }}>
            {["User", "Page", "When", "IP"].map((h, i) => (
              <th key={i} className="overline" style={{ fontSize: 10, padding: "12px 16px", textAlign: "left", borderBottom: "1px solid var(--border)" }}>{h}</th>
            ))}
          </tr></thead>
          <tbody>
            {events.length === 0 ? (
              <tr><td colSpan={4} style={{ padding: 24, textAlign: "center", color: "var(--text-2)" }}><Camera size={24} style={{ margin: "0 auto 8px" }} />{loading ? "Loading…" : "No screenshot attempts detected."}</td></tr>
            ) : events.map((e) => (
              <tr key={e.id} style={{ borderBottom: "1px solid var(--border)" }} data-testid={`screenshot-event-${e.id}`}>
                <td style={{ padding: "12px 16px", fontSize: 13, fontWeight: 600 }}>{e.user_name || "—"}</td>
                <td style={{ padding: "12px 16px", fontSize: 13, color: "var(--text-2)" }} className="font-mono-data">{e.page || "—"}</td>
                <td style={{ padding: "12px 16px", fontSize: 13, color: "var(--text-2)" }}>{fmtTime(e.at)}</td>
                <td style={{ padding: "12px 16px", fontSize: 13, color: "var(--text-2)" }} className="font-mono-data">{e.ip || "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
